import { Icon } from "@/components/icon";
import classNames from "classnames";
import { IButton } from "./button.types";

export const Button: IButton = ({ className, children, loading, ...rest }) => {
  return (
    <button
      className={classNames(
        "uppercase leading-none text-[16px] md:text-[18px] font-[800] text-black duration-200 cursor-pointer outline-0 border-0 bg-white hover:bg-hover py-[19.5px] md:py-[23.5px] px-[61px] flex items-center justify-center",
        className
      )}
      {...rest}
    >
      {!loading && children}
      {loading && (
        <Icon className="w-[20px] h-[20px] animate-spin" name="loading" />
      )}
    </button>
  );
};
